const ARCS = [
  {
    tag: "序幕",
    icon: "ri-heart-add-line",
    title: "意外的绑定",
    text: "主角在图书馆角落捡到一台会发光的心形装置，屏幕亮起「恋爱辅助器已激活」。原本波澜不惊的校园生活，就此被打开。",
  },
  {
    tag: "第一阶段",
    icon: "ri-pencil-ruler-line",
    title: "笨拙的初尝试",
    text: "在辅助器的引导下，主角第一次主动搭话、第一次约奶茶、第一次笨手笨脚地准备礼物。笑料百出，却也悄悄拉近了彼此距离。",
  },
  {
    tag: "第二阶段",
    icon: "ri-flag-2-line",
    title: "数值背后的真相",
    text: "当心动值一路飙升，主角却开始反思——这份好感究竟来自真实的自己，还是任务带来的表演？一场关于「真实与技巧」的抉择悄然展开。",
  },
  {
    tag: "第三阶段",
    icon: "ri-psychotherapy-line",
    title: "心之冻结与和解",
    text: "过度依赖辅助器触发了「心之冻结」，主角陷入迷茫。在不断失败、道歉与被原谅的过程中，他终于学会用本心面对身边的人。",
  },
  {
    tag: "高潮",
    icon: "ri-heart-3-fill",
    title: "不依赖系统的告白",
    text: "辅助器在关键时刻选择「静音」，把最后的决定交还主角。站在黄昏天台上，他终于说出那句不靠任何数值支撑的真心话。",
  },
  {
    tag: "尾声",
    icon: "ri-sun-line",
    title: "新的起点",
    text: "恋爱辅助器功成身退，化作一颗小小的纪念挂坠。主角带着成长后的勇气，继续书写属于他们的、更温暖的日常。",
  },
];

export default function Plot() {
  return (
    <section id="plot" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-700">
            <i className="ri-book-open-line"></i>
            剧情速览
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-900 md:text-4xl">
            恋爱辅助器<span className="text-primary-600">剧情梗概</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            从被动绑定到主动告白，故事沿着「笨拙尝试 → 迷失数值 → 找回本心」的主线层层推进。以下按阶段为你梳理整段剧情脉络。
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {ARCS.map((a, i) => (
            <article
              key={a.title}
              className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center justify-between">
                <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                  {a.tag}
                </span>
                <span className="font-heading text-2xl text-background-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <span className="mt-5 flex h-11 w-11 items-center justify-center rounded-2xl bg-accent-100 text-accent-700">
                <i className={`${a.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-xl text-foreground-900">{a.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{a.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}